export const colors = {
  primary: {
    base: "bg-primary-300/60 text-gray-700 border border-primary-200",
    gradient: "bg-linear-to-tr from-primary-50/30 to-primary-50",
    faint: "bg-primary-200/60 text-gray-600 border border-primary-200/20",
    bold: "bg-brand-blue text-black font-semibold border-blue-200 hover:bg-brand-blue/90 hover:border-blue-300 hover:ring-2 hover:ring-offset-2 hover:ring-brand-blue/20",
    hover: "hover:bg-primary-300/80 hover:text-gray-700",
    ring: "ring-primary-500/20",
    hover_ring: "hover:ring-primary-500/50",
    selection: "selection:bg-primary-500/10 selection:text-primary-900",
    marker: "marker:text-primary-200 marker:text-lg",
  },
  yellow: {
    base: "bg-yellow-300/60 text-gray-700 border border-yellow-200",
    gradient: "bg-linear-to-tr from-yellow-50/30 to-yellow-50",
    faint: "bg-yellow-200/60 text-gray-600 border border-yellow-200/20",
    bold: "bg-brand-yellow text-black font-semibold border-yellow-200 hover:bg-brand-yellow/90 hover:border-yellow-300 hover:ring-2 hover:ring-offset-2 hover:ring-yellow-200  ",
    hover: "hover:bg-yellow-300/80 hover:text-gray-700",
    ring: "ring-yellow-500/20",
    hover_ring: "hover:ring-yellow-500/50",
    selection: "selection:bg-yellow-500/10 selection:text-yellow-900",
    marker: "marker:text-yellow-300 marker:text-lg",
  },
  green: {
    base: "bg-green-300/60 text-gray-700 border border-green-200",
    gradient: "bg-linear-to-tr from-green-50/30 to-green-50",
    faint: "bg-green-200/60 text-gray-600 border border-green-200/20",
    bold: "bg-green-300 text-black font-semibold border-green-200 hover:bg-green-300/90 hover:border-green-300 hover:ring-2 hover:ring-offset-2 hover:ring-green-500/20",
    hover: "hover:bg-green-300/80 hover:text-gray-700",
    ring: "ring-green-500/20",
    hover_ring: "hover:ring-green-500/50",
    selection: "selection:bg-green-500/10 selection:text-green-900",
    marker: "marker:text-green-200 marker:text-lg",
  },
  blue: {
    base: "bg-blue-300/60 text-gray-700 border border-blue-200",
    gradient: "bg-linear-to-tr from-blue-50/30 to-blue-50",
    faint: "bg-blue-200/60 text-gray-600 border border-blue-200/20",
    bold: "bg-brand-blue text-black font-semibold border-blue-200 hover:bg-brand-blue/90 hover:border-blue-300 hover:ring-2 hover:ring-offset-2 hover:ring-brand-blue/20",
    hover: "hover:bg-blue-300/80 hover:text-gray-700",
    ring: "ring-blue-500/20",
    hover_ring: "hover:ring-blue-500/50",
    selection: "selection:bg-blue-500/10 selection:text-blue-900",
    marker: "marker:text-blue-200 marker:text-lg",
  },
  red: {
    base: "bg-red-300/60 text-gray-700 border border-red-200",
    gradient: "bg-linear-to-tr from-red-50/30 to-red-50",
    faint: "bg-red-200/60 text-gray-600 border border-red-200/20",
    bold: "bg-red-300 text-black font-semibold border-red-200 hover:bg-red-300/90 hover:border-red-300 hover:ring-2 hover:ring-offset-2 hover:ring-red-500/20",
    hover: "hover:bg-red-300/80 hover:text-gray-700",
    ring: "ring-red-500/20",
    hover_ring: "hover:ring-red-500/50",
    selection: "selection:bg-red-500/10 selection:text-red-900",
    marker: "marker:text-red-200 marker:text-lg",
  },
  purple: {
    base: "bg-purple-300/60 text-gray-700 border border-purple-200",
    gradient: "bg-linear-to-tr from-purple-50/30 to-purple-50",
    faint: "bg-purple-200/60 text-gray-600 border border-purple-200/20",
    bold: "bg-purple-300 text-black font-semibold border-purple-200 hover:bg-purple-300/90 hover:border-purple-300 hover:ring-2 hover:ring-offset-2 hover:ring-purple-500/20",
    hover: "hover:bg-purple-300/80 hover:text-gray-700",
    ring: "ring-purple-500/20",
    hover_ring: "hover:ring-purple-500/50",
    selection: "selection:bg-purple-500/10 selection:text-purple-900",
    marker: "marker:text-purple-200 marker:text-lg",
  },
  orange: {
    base: "bg-orange-300/60 text-gray-700 border border-orange-200",
    gradient: "bg-linear-to-tr from-orange-50/30 to-orange-50",
    faint: "bg-orange-200/60 text-gray-600 border border-orange-200/20",
    bold: "bg-orange-300 text-black font-semibold border-orange-200 hover:bg-orange-300/90 hover:border-orange-300 hover:ring-2 hover:ring-offset-2 hover:ring-orange-500/20",
    hover: "hover:bg-orange-300/80 hover:text-gray-700",
    ring: "ring-orange-500/20",
    hover_ring: "hover:ring-orange-500/50",
    selection: "selection:bg-orange-500/10 selection:text-orange-900",
    marker: "marker:text-orange-200 marker:text-lg",
  },
  pink: {
    base: "bg-pink-300/60 text-gray-700 border border-pink-200",
    gradient: "bg-linear-to-tr from-pink-50/30 to-pink-50",
    faint: "bg-pink-200/60 text-gray-600 border border-pink-200/20",
    bold: "bg-pink-100 text-black font-semibold border-pink-200 hover:bg-pink-100/90 hover:border-pink-300 hover:ring-2 hover:ring-offset-2 hover:ring-pink-500/20",
    hover: "hover:bg-pink-300/80 hover:text-gray-700",
    ring: "ring-pink-500/20",
    hover_ring: "hover:ring-pink-500/50",
    selection: "selection:bg-pink-500/10 selection:text-pink-900",
    marker: "marker:text-pink-200 marker:text-lg",
  },
  gray: {
    base: "bg-gray-300/60 text-gray-700 border border-gray-200",
    gradient: "bg-linear-to-tr from-gray-50/30 to-gray-50",
    faint: "bg-gray-200/60 text-gray-600 border border-gray-200/20",
    bold: "bg-gray-300 text-black font-semibold border-gray-200 hover:bg-gray-300/90 hover:border-gray-300 hover:ring-2 hover:ring-offset-2 hover:ring-gray-500/20",
    hover: "hover:bg-gray-300/80 hover:text-gray-700",
    ring: "ring-gray-500/20",
    hover_ring: "hover:ring-gray-500/50",
    selection: "selection:bg-gray-500/10 selection:text-gray-900",
    marker: "marker:text-gray-200 marker:text-lg",
  },
  teal: {
    base: "bg-teal-300/60 text-gray-700 border border-teal-200",
    gradient: "bg-linear-to-tr from-teal-50/30 to-teal-50",
    faint: "bg-teal-200/60 text-gray-600 border border-teal-200/20",
    bold: "bg-teal-300 text-black font-semibold border-teal-200 hover:bg-teal-300/90 hover:border-teal-300",
    hover: "hover:bg-teal-300/80 hover:text-gray-700",
    ring: "ring-teal-500/20",
    hover_ring: "hover:ring-teal-500/50",
    selection: "selection:bg-teal-500/10 selection:text-teal-900",
    marker: "marker:text-teal-200 marker:text-lg",
  },
  indigo: {
    base: "bg-indigo-300/60 text-gray-700 border border-indigo-200",
    gradient: "bg-linear-to-tr from-indigo-50/30 to-indigo-50",
    faint: "bg-indigo-200/60 text-gray-600 border border-indigo-200/20",
    bold: "bg-indigo-300 text-black font-semibold border-indigo-200 hover:bg-indigo-300/90 hover:border-indigo-300 hover:ring-2 hover:ring-offset-2 hover:ring-indigo-500/20",
    hover: "hover:bg-indigo-300/80 hover:text-gray-700",
    ring: "ring-indigo-500/20",
    hover_ring: "hover:ring-indigo-500/50",
    selection: "selection:bg-indigo-500/10 selection:text-indigo-900",
    marker: "marker:text-indigo-200 marker:text-lg",
  },
  violet: {
    base: "bg-violet-300/60 text-gray-700 border border-violet-200",
    gradient: "bg-linear-to-tr from-violet-50/30 to-violet-50",
    faint: "bg-violet-200/60 text-gray-600 border border-violet-200/20",
    bold: "bg-violet-300 text-black font-semibold border-violet-200 hover:bg-violet-300/90 hover:border-violet-300",
    hover: "hover:bg-violet-300/80 hover:text-gray-700",
    ring: "ring-violet-500/20",
    hover_ring: "hover:ring-violet-500/50",
    selection: "selection:bg-violet-500/10 selection:text-violet-900",
    marker: "marker:text-violet-200 marker:text-lg",
  },
  fuchsia: {
    base: "bg-fuchsia-300/60 text-gray-700 border border-fuchsia-200",
    gradient: "bg-linear-to-tr from-fuchsia-50/30 to-fuchsia-50",
    faint: "bg-fuchsia-200/60 text-gray-600 border border-fuchsia-200/20",
    bold: "bg-fuchsia-300 text-black font-semibold border-fuchsia-200 hover:bg-fuchsia-300/90 hover:border-fuchsia-300 hover:ring-2 hover:ring-offset-2 hover:ring-fuchsia-500/20",
    hover: "hover:bg-fuchsia-300/80 hover:text-gray-700",
    ring: "ring-fuchsia-500/20",
    hover_ring: "hover:ring-fuchsia-500/50",
    selection: "selection:bg-fuchsia-500/10 selection:text-fuchsia-900",
    marker: "marker:text-fuchsia-200 marker:text-lg",
  },
  rose: {
    base: "bg-rose-300/60 text-gray-700 border border-rose-200",
    gradient: "bg-linear-to-tr from-rose-50/30 to-rose-50",
    faint: "bg-rose-200/60 text-gray-600 border border-rose-200/20",
    bold: "bg-rose-300 text-black font-semibold border-rose-200 hover:bg-rose-300/90 hover:border-rose-300 hover:ring-2 hover:ring-offset-2 hover:ring-rose-500/20",
    hover: "hover:bg-rose-300/80 hover:text-gray-700",
    ring: "ring-rose-500/20",
    hover_ring: "hover:ring-rose-500/50",
    selection: "selection:bg-rose-500/10 selection:text-rose-900",
    marker: "marker:text-rose-200 marker:text-lg",
  },
  sky: {
    base: "bg-sky-300/60 text-gray-700 border border-sky-200",
    gradient: "bg-linear-to-tr from-sky-50/30 to-sky-50",
    faint: "bg-sky-200/60 text-gray-600 border border-sky-200/20",
    bold: "bg-sky-300 text-black font-semibold border-sky-200 hover:bg-sky-300/90 hover:border-sky-300 hover:ring-2 hover:ring-offset-2 hover:ring-sky-500/20",
    hover: "hover:bg-sky-300/80 hover:text-gray-700",
    ring: "ring-sky-500/20",
    hover_ring: "hover:ring-sky-500/50",
    selection: "selection:bg-sky-500/10 selection:text-sky-900",
    marker: "marker:text-sky-200 marker:text-lg",
  },
  lime: {
    base: "bg-lime-300/60 text-gray-700 border border-lime-200",
    gradient: "bg-linear-to-tr from-lime-50/30 to-lime-50",
    faint: "bg-lime-200/60 text-gray-600 border border-lime-200/20",
    bold: "bg-lime-300 text-black font-semibold border-lime-200 hover:bg-lime-300/90 hover:border-lime-300 hover:ring-2 hover:ring-offset-2 hover:ring-lime-500/20",
    hover: "hover:bg-lime-300/80 hover:text-gray-700",
    ring: "ring-lime-500/20",
    hover_ring: "hover:ring-lime-500/50",
    selection: "selection:bg-lime-500/10 selection:text-lime-900",
    marker: "marker:text-lime-200 marker:text-lg",
  },
}

export const colorClasses = Object.fromEntries(
  Object.entries(colors).map(([key, value]) => [key, value.base])
)